import React, { Component } from "react";
import DefaultLayout from "layouts/Default";
import "./index.scss";
import { RouteComponentProps } from "react-router";
import NextRouteURLs from "NextRouteURLs";
import ContentFAQ from "components/content/ContentFAQ";
import ContentPageProvider from "components/content/ContentPageProvider";
import Banner from "components/banner/";
import BookingEnquiryForm from "components/bookings/BookingEnquiryForm";

export default class FAQPage extends Component<RouteComponentProps, any> {
  onContactClick = () => {
    window.location.href = NextRouteURLs.CONTACT
  };

  render() {
    return (
      <DefaultLayout id="faq-page">
        <ContentPageProvider url={this.props.location.pathname}>
          <Banner />
          <section className="content-mw answers">
            <ContentFAQ sectionTitle="We have the answers" code="answers" />
          </section>
          <section className="content-mw additional-info">
            <ContentFAQ
              sectionTitle="Additional Information"
              code="additional"
            />
          </section>

          {/* <section className="content-mw contact">
            <Typography className="section-title" variant="h2" component="h2">
              Didn’t find the answer you are looking for?
            </Typography>
            <Typography className="text" variant="body1" component="div">
              Our team would love to field any questions or concerns you may
              have. Fire them through to us and someone will get back to you
              shortly.
            </Typography>
            <Button
              variant="contained"
              color="primary"
              onClick={this.onContactClick}
            >
              Get in touch
            </Button>
          </section> */}
          <BookingEnquiryForm />
        </ContentPageProvider>
      </DefaultLayout>
    );
  }
}
